exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".watchlist-btn{background:transparent;border:none;cursor:pointer}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Templates/dislikeBtn.vue"],"names":[],"mappings":"AACA,eAAe,uBAAuB,YAAY,cAAc,CAC/D","file":"dislikeBtn.vue","sourcesContent":["\n.watchlist-btn{background:transparent;border:none;cursor:pointer\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27e2a8ee","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Templates/dislikeBtn.vue
// module id = 414
// module chunks = 23